import React, { Component } from 'react';
import CKEditor from "react-ckeditor-component";
class Ckeditor extends Component {
    constructor(props) {
        super(props);
        this.updateContent = this.updateContent.bind(this);
        this.state = {
            content: 'content',
        }
    }

    updateContent(newContent) {
        // this.setState({
        // 	content: newContent
        // })
    }

    onChange(evt) {
        // this.setState({
        // 	content: newContent
        // })
    }

    onBlur(evt) {
    }

    afterPaste(evt) {
    }
    render() {
        return (
            <div>
                <CKEditor
                    content={this.state.content}
                    events={{
                        "blur": this.onBlur,
                        "afterPaste": this.afterPaste,
                        "change": this.onChange
                    }}
                />
            </div>
        );
    }
}

export default Ckeditor;
